export * from 'SourceRoute/ProductPage/ProductPage.config';

export const PRODUCT_APPLICABILITY = 'applicability';
export const TECHNICAL_DETAILS = 'technical_details';
export const PRODUCT_ATTACHMENTS = 'product_attachments';
export const STATIC_SECTION_CMS_BLOCK_ID = 'info_tiles';
export const RECOMMENDED_CATEGORIES = 'promo_banners_PDP';
export const REWARD_POINTS_PDP = 'reward_points_pdp';
export const PAYMENT_DEADLINE = 'payment_deadline';
